<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="订单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入订单号">
						</el-input>
					</el-form-item>
					<el-form-item label="账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户账号">
						</el-input>
					</el-form-item>
					
					<el-form-item label="状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="0" label="审核中" value="0">审核中</el-option>
							<el-option key="1" label="转帐中" value="1">转帐中</el-option>
							<el-option key="2" label="提现成功" value="2">提现成功</el-option>
							<el-option key="3" label="用户撤销" value="3">用户撤销</el-option>
							<el-option key="4" label="驳回" value="4">驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="更新时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				searchInfo:{}
			}
		},
		
		methods:{
			// 查询
			search(){
				
			},
			// 清空
			empty(){
				
			},
			// 导出
			downloadFile(){
				
			}
		}
	}
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}
	
	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}
	
	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
	
	.lpc-quill img {
		width: 100px;
		height: 120px;
	}
	
	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>